angular.module('ui.report.reportRouteContainer', [])

    .config(function ($stateProvider) {
        $stateProvider.state('client.report', {
            url: '/report',
            templateUrl: 'app/ui/report/reportRouteContainer/reportRouteContainer.html',
            data: {pageTitle: 'OM: Report'}
        });
    })

    .run(function ($rootScope, $state, reportManager, gettextCatalog, toastr) {
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            if (toState.name === 'client.report' && !reportManager.getReportConfig()) {
                event.preventDefault();
                $state.go('client.home');
                toastr.warning('No context data configured for the report!', gettextCatalog.getString('Invalid Operation'));
            }
        });
    })

;
